<template>
  <section v-if="representatives" class="experts">
    <div class="experts__column">
      <div v-for="rep in colLeft" :key="rep._uid" class="experts__card">
        <BaseNuxtImage
          :src="rep.content.image?.filename || ''"
          :alt="rep.content.image?.alt || ''"
          class="experts__card-photo"
        />
        <p class="experts__card-description">{{ rep.content.description }}</p>
        <p class="experts__card-name">{{ rep.content.name }}</p>
        <p class="experts__card-position">{{ rep.content.role }}</p>
      </div>
    </div>
    <div class="experts__column">
      <div class="experts__card shadow-grey-small">
        <h5>{{ $t('common.events.schedule_time') }}</h5>
        <a target="_blank" class="button" :href="scheduleLink">
          {{ $t('common.form.schedule_meeting') }}
        </a>
      </div>
      <div
        v-for="rep in colRight"
        :key="rep._uid"
        class="experts__card shadow-grey-small"
      >
        <BaseNuxtImage
          :src="rep.content.image?.filename || ''"
          :alt="rep.content.image?.alt || ''"
          class="experts__card-photo"
        />
        <p class="experts__card-description">{{ rep.content.description }}</p>
        <p class="experts__card-name">{{ rep.content.name }}</p>
        <p class="experts__card-position">{{ rep.content.role }}</p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { EventRepresentativeStoryblok } from '@/types'

interface Props {
  representatives?: EventRepresentativeStoryblok[]
  scheduleLink: string
}

const props = defineProps<Props>()

const colLeft = computed(() => {
  return props.representatives?.filter((_, i) => i % 2 === 0)
})

const colRight = computed(() => {
  return props.representatives?.filter((_, i) => i % 2 !== 0)
})
</script>

<style lang="scss" scoped>
.experts {
  display: flex;
  flex-direction: column-reverse;
  row-gap: 20px;

  @media (min-width: $breakpoint-md) {
    flex-direction: row;
    column-gap: 20px;
  }

  &__card {
    border-radius: 16px;
    background-color: white;
    padding: 32px;

    @media (min-width: $breakpoint-md) {
      padding: 48px;
    }
  }

  &__card-photo {
    width: 100%;
    height: auto;
    border-radius: 50%;
    object-fit: cover;
    max-width: 148px;
    margin-bottom: 48px;
  }

  &__card-description {
    margin-bottom: 32px;
  }

  &__card-name {
    font-weight: var(--font-weight-paragraph-bold);
    font-size: var(--font-size-paragraph-l);
    margin-bottom: 4px;
  }

  &__card-position {
    margin-bottom: 0;
  }

  &__column {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  }
}
</style>
